export const PRODUCT_NAME = 'OkGrow';
export const ADMIN_USER_LIST_VIEW_PAGE_SIZE = 10;
export const ADMIN_ORGANIZATION_LIST_VIEW_PAGE_SIZE = 10;

export const ROOT_DOMAIN = process.env.NODE_ENV === 'production' ? 'okgrow.com' : 'af.com:3002'; 
export const APP_DOMAIN = `${ROOT_DOMAIN}/app`;
export const DEV_PORT = `3002`;
export const PROTOCOL = process.env.NODE_ENV === 'production' ? 'https' : 'http';
export const ROOT_URL_PATH = `${PROTOCOL}://${process.env.NODE_ENV === 'production' ? `www.${ROOT_DOMAIN}` : ROOT_DOMAIN}`;

export const USE_CHARGEBEE_HOSTED_PAGE = true;

export const DEMO_USER_EMAIL = "demo@okgrow.com"
export const DEMO_USER_PASSWORD = "123123"
export const DEMO_USER_ID = "e89ebe84-dbfa-4eeb-90b0-576eb0fc3efe"
export const DEMO_ACCOUNT_ID = "c8661641-a2e9-41d2-9c9e-2f63e781af56"
export const DEMO_ACCOUNT_IDS = ["c8661641-a2e9-41d2-9c9e-2f63e781af56", "7ed50c53-c969-4fa3-bd1d-c390c5f9a014"]

export const enabledLocales = [
  "en",
  // "es",
  // "pt"
  // "ro",
  // "fr",
  // "de",
  // "it",
]

export const globalMetadata = {
  siteName: 'OkGrow',
  siteUrl: `https://www.okgrow.com`,
  siteLogo: 'https://www.okgrow.com/img/okgrow-logo.png',
  email: 'support@okgrow.com',
  description: `OkGrow is the best AI TikTok growth service that helps you grow your TikTok account organically and automatically.`,
};

export const targetingOptionsDefault = {
  "features": {
    "like": true,
    "story_views": true,
    "comment_like": true,
    "other": true
  },
  "general": {
    "speed": "slow",
    "gender": "any",
  },
  "interests": {},
  "locations": {
    "canada": true,
    "europe": true,
    "united-states": true
  }
}

export const competitorList = [
  { name: "Ampfluence", url: "https://ampfluence.com", description: `Ampfluence is an TikTok growth service that offers various growth options, including targeted growth campaigns and content creation services. However, their pricing plans can be expensive, and their growth results are not always significant. In this review, we'll compare Ampfluence with OkGrow, a more affordable and effective TikTok growth service that uses advanced AI technology to target real and engaged users.`},
  { name: "HypePlanner",url: "https://hypeplanner.com",description: `HypePlanner is an TikTok growth service that promises to help you grow your TikTok followers. Are you wondering if it is worth your time and money? Check out our honest review of HypePlanner and compare it with other TikTok growth services in the market, including OkGrow.`},
  { name: "HighSocial", url: "https://www.highsocial.com", description: `HighSocial is a TikTok growth service that claims to provide organic growth for your account. However, their methods may not always align with TikTok's terms of service, putting your account at risk. OkGrow offers a safer, more effective alternative using AI-driven strategies to target real, engaged users. Our service not only grows your following but also improves engagement rates, all while keeping your account secure. Read our comparison to see why OkGrow is the superior choice for sustainable TikTok growth.` },
  { name: "Tikfame", url: "https://tikfame.co", description: `Tikfame promises quick TikTok growth through various packages, but their methods often involve artificial engagement that can harm your account's credibility. In contrast, OkGrow focuses on organic, sustainable growth using advanced AI technology. We target real users who are genuinely interested in your content, leading to higher-quality followers and better long-term results. Our approach not only grows your audience but also protects your account's integrity. Discover why OkGrow is the smarter choice for authentic TikTok growth.` },
  { name: "Ampfluence", url: "https://www.ampfluence.com", description: `Ampfluence offers TikTok growth services, but their approach may not be as tailored or effective as you need. OkGrow provides a more sophisticated, AI-driven growth strategy that focuses on attracting real, engaged followers who are genuinely interested in your content. Our service not only increases your follower count but also improves your overall engagement rates. With OkGrow, you'll experience more sustainable growth and better ROI compared to Ampfluence. Read our detailed comparison to understand why OkGrow is the superior choice for serious TikTok creators and businesses.` },
  { name: "GrowTok", url: "https://www.growtok.com", description: `GrowTok claims to offer TikTok growth services, but their methods may not always align with TikTok's best practices. OkGrow, on the other hand, uses cutting-edge AI technology to deliver organic, sustainable growth that doesn't put your account at risk. Our service targets real users who are likely to engage with your content, leading to higher-quality followers and better engagement rates. Unlike GrowTok, OkGrow's approach focuses on long-term success rather than quick, potentially harmful gains. Discover why OkGrow is the smarter choice for authentic TikTok growth.` },
  { name: "Influensly", url: "https://influensly.com", description: `Influensly offers TikTok growth services, but their approach may lack the sophistication needed for truly effective growth. OkGrow utilizes advanced AI algorithms to target and attract real, engaged followers who are genuinely interested in your content. Our service not only increases your follower count but also improves your overall engagement rates, leading to more sustainable growth. Unlike Influensly, OkGrow's strategies are always in line with TikTok's terms of service, ensuring your account remains safe while growing. Compare OkGrow with Influensly to see why we're the better choice for serious TikTok creators and businesses.` },
  { name: "Social Buddy", url: "https://socialbuddy.com", description: `Social Buddy offers TikTok growth services, but their methods may not be as effective or safe as you need. OkGrow provides a more advanced, AI-driven approach to TikTok growth that focuses on attracting real, engaged followers. Our service not only increases your follower count but also improves your overall engagement rates, leading to more meaningful interactions and potential conversions. Unlike Social Buddy, OkGrow's strategies are always in compliance with TikTok's guidelines, ensuring your account's safety and longevity. Read our detailed comparison to understand why OkGrow is the superior choice for sustainable TikTok growth.` },
]

// Country names object using 2-letter country codes to reference country name
export const countryList = {"AF": "Afghanistan", "AL": "Albania", "DZ": "Algeria", "AD": "Andorra", "AO": "Angola", "AG": "Antigua and Barbuda", "AR": "Argentina", "AM": "Armenia", "AU": "Australia", "AT": "Austria", "AZ": "Azerbaijan", "BS": "Bahamas", "BH": "Bahrain", "BD": "Bangladesh", "BB": "Barbados", "BY": "Belarus", "BE": "Belgium", "BZ": "Belize", "BJ": "Benin", "BT": "Bhutan", "BO": "Bolivia", "BA": "Bosnia and Herzegovina", "BW": "Botswana", "BR": "Brazil", "BN": "Brunei Darussalam", "BG": "Bulgaria", "BF": "Burkina Faso", "BI": "Burundi", "CV": "Cabo Verde", "KH": "Cambodia", "CM": "Cameroon", "CA": "Canada", "CF": "Central African Republic", "TD": "Chad", "CL": "Chile", "CN": "China", "CO": "Colombia", "KM": "Comoros", "CD": "Congo", "CG": "Congo", "CR": "Costa Rica", "HR": "Croatia", "CU": "Cuba", "CW": "Cura\u00e7ao", "CY": "Cyprus", "CZ": "Czechia", "CI": "C\u00f4te d'Ivoire", "DK": "Denmark", "DJ": "Djibouti", "DM": "Dominica", "DO": "Dominican Republic", "EC": "Ecuador", "EG": "Egypt", "SV": "El Salvador", "GQ": "Equatorial Guinea", "ER": "Eritrea", "EE": "Estonia", "SZ": "Eswatini", "ET": "Ethiopia", "FJ": "Fiji", "FI": "Finland", "FR": "France", "GF": "French Guiana", "GA": "Gabon", "GM": "Gambia", "GE": "Georgia", "DE": "Germany", "GH": "Ghana", "GR": "Greece", "GD": "Grenada", "GT": "Guatemala", "GG": "Guernsey", "GN": "Guinea", "GW": "Guinea-Bissau", "GY": "Guyana", "HT": "Haiti", "VA": "Holy See", "HN": "Honduras", "HK": "Hong Kong", "HU": "Hungary", "IS": "Iceland", "IN": "India", "ID": "Indonesia", "IQ": "Iraq", "IE": "Ireland", "IL": "Israel", "IT": "Italy", "JM": "Jamaica", "JP": "Japan", "JO": "Jordan", "KZ": "Kazakhstan", "KE": "Kenya", "KI": "Kiribati", "KP": "Korea", "KR": "Korea", "KW": "Kuwait", "KG": "Kyrgyzstan", "LA": "Lao People's Democratic Republic", "LV": "Latvia", "LB": "Lebanon", "LS": "Lesotho", "LR": "Liberia", "LY": "Libya", "LI": "Liechtenstein", "LT": "Lithuania", "LU": "Luxembourg", "MO": "Macao", "MG": "Madagascar", "MW": "Malawi", "MY": "Malaysia", "MV": "Maldives", "ML": "Mali", "MT": "Malta", "MH": "Marshall Islands", "MR": "Mauritania", "MU": "Mauritius", "YT": "Mayotte", "MX": "Mexico", "FM": "Micronesia", "MD": "Moldova", "MC": "Monaco", "MN": "Mongolia", "ME": "Montenegro", "MA": "Morocco", "MZ": "Mozambique", "MM": "Myanmar", "NA": "Namibia", "NR": "Nauru", "NP": "Nepal", "NL": "Netherlands", "NZ": "New Zealand", "NI": "Nicaragua", "NE": "Niger", "NG": "Nigeria", "NO": "Norway", "OM": "Oman", "PK": "Pakistan", "PW": "Palau", "PA": "Panama", "PG": "Papua New Guinea", "PY": "Paraguay", "PE": "Peru", "PH": "Philippines", "PL": "Poland", "PT": "Portugal", "PR": "Puerto Rico", "QA": "Qatar", "MK": "Republic of North Macedonia", "RO": "Romania", "RU": "Russian Federation", "RW": "Rwanda", "SA": "Saudi Arabia", "SN": "Senegal", "RS": "Serbia", "SC": "Seychelles", "SL": "Sierra Leone", "SG": "Singapore", "SK": "Slovakia", "SI": "Slovenia", "SB": "Solomon Islands", "SO": "Somalia", "ZA": "South Africa", "GS": "South Georgia and the South Sandwich Islands", "SS": "South Sudan", "ES": "Spain", "LK": "Sri Lanka", "SD": "Sudan", "SR": "Suriname", "SJ": "Svalbard and Jan Mayen", "SE": "Sweden", "CH": "Switzerland", "TW": "Taiwan", "TJ": "Tajikistan", "TZ": "Tanzania, United Republic of", "TH": "Thailand", "TL": "Timor-Leste", "TG": "Togo", "TO": "Tonga", "TT": "Trinidad and Tobago", "TN": "Tunisia", "TR": "Turkey", "TM": "Turkmenistan", "UG": "Uganda", "UA": "Ukraine", "AE": "United Arab Emirates", "GB": "United Kingdom", "US": "United States of America", "UY": "Uruguay", "UZ": "Uzbekistan", "VU": "Vanuatu", "VE": "Venezuela", "VN": "Viet Nam", "YE": "Yemen", "ZM": "Zambia", "ZW": "Zimbabwe"}
export const countryEmojis = {
  'United States': '🇺🇸',
  'India': '🇮🇳',
  'United Kingdom': '🇬🇧',
  'Germany': '🇩🇪',
  'Canada': '🇨🇦',
  'France': '🇫🇷',
  'Australia': '🇦🇺',
  'Japan': '🇯🇵',
  'Netherlands': '🇳🇱',
  'Sweden': '🇸🇪',
  'Brazil': '🇧🇷',
  'Spain': '🇪🇸',
  'Italy': '🇮🇹',
  'Mexico': '🇲🇽',
  'Indonesia': '🇮🇩',
  'Russia': '🇷🇺',
  'Turkey': '🇹🇷',
  'Poland': '🇵🇱',
  'Switzerland': '🇨🇭',
  'Belgium': '🇧🇪',
  'South Africa': '🇿🇦',
  'Argentina': '🇦🇷',
  'Philippines': '🇵🇭',
  'Malaysia': '🇲🇾',
  'Nigeria': '🇳🇬',
  'Chile': '🇨🇱',
  'Colombia': '🇨🇴',
  'Saudi Arabia': '🇸🇦',
  'Portugal': '🇵🇹',
  'Romania': '🇷🇴',
  'Greece': '🇬🇷',
  'Hungary': '🇭🇺',
  'Pakistan': '🇵🇰',
  'Austria': '🇦🇹',
  'Ukraine': '🇺🇦',
  'Czech Republic': '🇨🇿',
  'Vietnam': '🇻🇳',
  'Thailand': '🇹🇭',
  'Bulgaria': '🇧🇬',
  'Morocco': '🇲🇦',
  'Peru': '🇵🇪',
  'Moldova': '🇲🇩',
  'Montenegro': '🇲🇪',
  'Monaco': '🇲🇨',
  'Luxembourg': '🇱🇺',
  'Lithuania': '🇱🇹',
  'Latvia': '🇱🇻',
  'United Arab Emirates': '🇦🇪',
  'South Korea': '🇰🇷',
  'Ireland': '🇮🇪',
  'Egypt': '🇪🇬',
  'Israel': '🇮🇱',
  'Singapore': '🇸🇬',
  'Norway': '🇳🇴',
  'Finland': '🇫🇮',
  'Denmark': '🇩🇰',
  'Croatia': '🇭🇷',
  'New Zealand': '🇳🇿',
  'China': '🇨🇳',
  'Venezuela': '🇻🇪',
  'Qatar': '🇶🇦',
  'Serbia': '🇷🇸',
  'Slovakia': '🇸🇰',
  'Belarus': '🇧🇾',
  'Ecuardor': '🇪🇨',
  'Slovenia': '🇸🇮',
  'Hong Kong': '🇭🇰',
  'Bangladesh': '🇧🇩',
  'Iraq': '🇮🇶',
  'Puerto Rico': '🇵🇷',
  'Bosnia and Herzegovina': '🇧🇦',
  'Estonia': '🇪🇪',
  'Georgia': '🇬🇪',
  'Iceland': '🇮🇸',
  'Jamaica': '🇯🇲',
  'Maldives': '🇲🇻',
  'Bahamas': '🇧🇸',
};
export const countryPopulations = {
  'United States': 331002651,
  'United Kingdom': 67886011,
  'Canada': 37742154,
  'Australia': 25499884,
  'Germany': 83783942,
  'France': 65273511,
  'Italy': 60461826,
  'Spain': 46754778,
  'Netherlands': 17134872,
  'Switzerland': 8654622,
  'Sweden': 10099265,
  'Belgium': 11589623,
  'Austria': 9006398,
  'Poland': 37846611,
  'Russia': 145934462,
  'Japan': 126476461,
  'South Africa': 59308690,
  'Brazil': 212559417,
  'Mexico': 128932753,
  'Argentina': 45195774,
  'Colombia': 50882891,
  'Chile': 19116201,
  'India': 1380004385,
  'Indonesia': 273523615,
  'Malaysia': 32365999,
  'Philippines': 109581078,
  'Turkey': 84339067,
  'Saudi Arabia': 34813871,
  'Portugal': 10196709,
  'Romania': 19237691,
  'Greece': 10423054,
  'Hungary': 9660351,
  'Pakistan': 220892340,
  'Ukraine': 44134693,
  'Czech Republic': 10708981,
  'Vietnam': 97338579,
  'Thailand': 69799978,
  'Bulgaria': 6948445,
  'Morocco': 36910560,
  'Peru': 32971854,
  'Moldova': 4033963,
  'Montenegro': 628066,
  'Monaco': 39242,
  'Luxembourg': 625978,
  'Lithuania': 2722289,
  'Latvia': 1886198,
  'United Arab Emirates': 9890402,
  'South Korea': 51269185,
  'Ireland': 4937786,
  'Egypt': 102334404,
  'Israel': 8655535,
  'Singapore': 5850342,
  'Norway': 5421241,
  'Finland': 5540720,
  'Denmark': 5792202,
  'Croatia': 4105267,
  'New Zealand': 4822233,
  'China': 1439323776,
  'Venezuela': 28435940,
  'Qatar': 2881053,
  'Serbia': 8737371,
  'Slovakia': 5459642,
  'Belarus': 9449323,
  'Ecuador': 17643054,
  'Slovenia': 2078938,
  'Hong Kong': 7496981,
  'Bangladesh': 164689383,
  'Iraq': 40222493,
  'Puerto Rico': 3194034,
  'Bosnia and Herzegovina': 3280819,
  'Estonia': 1326535,
  'Georgia': 3989167,
  'Iceland': 364134,
  'Jamaica': 2961167,
  'Maldives': 540544,
  'Bahamas': 393248,
}
